// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal__container","fadeIn":"Modal__fadeIn","content":"Modal__content","video":"Modal__video","product":"Modal__product"};